<template>
  <Dropdown
    trigger="click"
    class="rp-insert-param-dropdown"
    transfer-class-name="rp-insert-param-transfer"
    :placement="placement"
    @on-click="onSelect"
  >
    <Button
      type="default"
      size="small"
      class="rp-insert-param-btn"
      :class="{ 'rp-insert-param-btn--footer': buttonStyle === 'footer' }"
    >+ 插入参数</Button>
    <DropdownMenu slot="list">
      <DropdownItem
        v-for="item in insertParamOptions"
        :key="item.token"
        :name="item.token"
        class="rp-insert-param-item"
      >
        <span class="rp-insert-param-row">
          <span class="rp-insert-param-row__label">{{ item.label }}</span>
          <span class="rp-insert-param-row__token">{{ item.token }}</span>
        </span>
      </DropdownItem>
      <DropdownItem v-if="!insertParamOptions.length" disabled>
        请先在通话控制中配置客户信息参数
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import { buildCustomerInfoInsertParamOptions } from '../../utils/flowSectionHelpers'

export default {
  name: 'LlmInsertParamDropdown',
  props: {
    customerInfoParams: {
      type: Array,
      default: () => [],
    },
    placement: {
      type: String,
      default: 'bottom-end',
    },
    buttonStyle: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    insertParamOptions() {
      return buildCustomerInfoInsertParamOptions(this.customerInfoParams)
    },
  },
  methods: {
    onSelect(name) {
      if (name == null || name === '') return
      this.$emit('insert', String(name))
    },
  },
}
</script>

<style lang="scss" scoped>
.rp-insert-param-dropdown {
  flex-shrink: 0;
}

.rp-insert-param-btn {
  height: 28px !important;
  padding: 0 12px !important;
  border: 1px solid #91d5ff !important;
  border-radius: 4px !important;
  background: #e6f7ff !important;
  color: #1890ff !important;
  font-size: 14px !important;
  line-height: 26px !important;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover,
  &:focus {
    border-color: #1890ff !important;
    color: #0050b3 !important;
    background: #bae7ff !important;
    box-shadow: 0 1px 4px rgba(24, 144, 255, 0.18) !important;
  }

  &--footer {
    height: auto !important;
    min-height: 24px;
    padding: 4px 10px !important;
    border: none !important;
    border-radius: 4px !important;
    background: transparent !important;
    color: #5668f0 !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    box-shadow: none !important;

    &:hover,
    &:focus {
      border: none !important;
      background: #eef0fe !important;
      color: #404eec !important;
      box-shadow: none !important;
    }

    &:active {
      background: #e0e4fc !important;
      color: #3648d9 !important;
    }
  }
}
</style>

<style lang="scss">
.rp-insert-param-transfer.ivu-select-dropdown {
  min-width: 200px;
}
.rp-insert-param-transfer .ivu-dropdown-menu {
  padding: 4px 0;
}
.rp-insert-param-transfer .ivu-dropdown-item.rp-insert-param-item {
  padding: 10px 14px !important;
  line-height: normal !important;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #f5f7ff !important;
  }
}
.rp-insert-param-transfer .rp-insert-param-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-width: 150px;
}
.rp-insert-param-transfer .rp-insert-param-row__label {
  font-size: 14px;
  color: #262626;
}
.rp-insert-param-transfer .rp-insert-param-row__token {
  font-size: 14px;
  color: #1890ff;
  flex-shrink: 0;
}

/* View Design Button 默认 hover 会盖过 scoped，footer 样式需全局补强 */
.rp-insert-param-btn.rp-insert-param-btn--footer.ivu-btn-default:hover,
.rp-insert-param-btn.rp-insert-param-btn--footer.ivu-btn-default:focus {
  border-color: transparent !important;
  background: #eef0fe !important;
  color: #404eec !important;
}

.rp-insert-param-btn.rp-insert-param-btn--footer.ivu-btn-default:active {
  background: #e0e4fc !important;
  color: #3648d9 !important;
}
</style>
